import { Button } from 'primereact/button';
import React, { ReactNode, useContext, useState } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { LabelledInputText } from '../../../components/form/LabelledInputText';
import { ReadWritePermissions } from '../../../../Auth/components/PermissionGate';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { ApiResponse, PublisherApi, PublisherDTO } from '../../../../api/core';
import { AuthContext } from '../../../../Auth/components/AuthProvider';
import { getAuthMiddleware } from '../../../../Auth/utils/GetAuthMiddleware';
import { ToastContext, ToastContextType } from '../../../../util/providers/ToastProvider';

interface Props {
  permissions: ReadWritePermissions;
  onSubmit: (publisher: PublisherDTO) => void;
}

export const WorkPublisherAdd = (props: Props): ReactNode => {
  const [publisher, setPublisher] = useState<string>('');
  const [visible, setVisible] = useState<boolean>(false);
  const {actions} = useContext(AuthContext);
  const api: PublisherApi = new PublisherApi().withMiddleware(getAuthMiddleware(actions));
  const intl: IntlShape = useIntl();
  const toast: ToastContextType = useContext(ToastContext);
  return (
    <div className={`flex justify-content-end`}>
      <ConfirmDialog
        visible={visible}
        onHide={() => setVisible(false)}
        header={intl.formatMessage({id: 'work.attr.publisher.attr.create'})}
        message={
          <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
            <LabelledInputText
              id={'addPublisher'}
              value={publisher}
              permissions={props.permissions}
              validation={{valid: publisher.length > 0}}
              onChange={(value: string): void => setPublisher(value)}
              title={`work.attr.publisher.attr.publisher`}
            />
          </div>
        }
        rejectLabel={intl.formatMessage({id: 'button.abort'})}
        acceptLabel={intl.formatMessage({id: 'button.add'})}
        accept={(): void => {
          if (publisher.trim().length < 0) {
            return;
          }
          api.createPublisherRaw({publisherDTO: {id: null, name: publisher.trim()}})
            .then(async (response: ApiResponse<PublisherDTO>): Promise<void> => {
              if (!response.raw.ok) {
                toast.error(response, 'message.saving.failed');
              }
              const publisherDto = await response.value();
              props.onSubmit(publisherDto);
              setPublisher('');
              setVisible(false);
            })
            .catch(e => {
              toast.error(e, 'message.saving.failed');
            });
        }}
        reject={(): void => {
          setPublisher('');
          setVisible(false);
        }}
      />
      <Button
        icon={'pi pi-plus-circle'}
        disabled={props.permissions && !props.permissions.canWrite}
        label={intl.formatMessage({id: `work.attr.publisher.attr.create`})}
        onClick={(): void => setVisible(true)}/>
    </div>
  );
};
